module.exports = __webpack_public_path__ + "img/04-B11.1445b420.png";